const banner = {
  getlist: 'banner/getlist',
  add: 'banner/add',
  update: 'banner/update',
  remove: 'banner/remove',
  get: 'banner/get',
  clearcache: 'banner/clear-cache',
}
export default banner
